class ProductDescription extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelectorAll(".button--primary");
    this.moreInfo = this.querySelector(".description_cta_wrapper.wrapper_more");
    this.lessInfo = this.querySelector(".description_cta_wrapper.wrapper_less");

    this.button.forEach((btn) => {
      btn.addEventListener("click", this.handleOpen.bind(this));
    });
  }

  handleOpen() {
    this.classList.toggle("open");

    if (this.classList.contains("open")) {
      this.moreInfo.classList.remove("active");
      this.lessInfo.classList.add("active");
      return;
    }

    this.scrollIntoView({ block: "start", behavior: "smooth" });
    this.moreInfo.classList.add("active");
    this.lessInfo.classList.remove("active");
  }
}

customElements.define("product-description", ProductDescription);
